export function fetch(id) { return { type: 'STAFFS/FETCH', id } }
export function fetch_one(id) { return { type: 'COORP/FETCH', id } }
export function fetch_all(id) { return { type: 'COORPS/FETCH/ALL', id } }
export function fetch_bookings(id) { return { type: 'GUEST/BOOKINGS/FETCH', id } }
export function archive(id, IdProperty) { return { type: 'STAFF/ARCHIVE', id, IdProperty } }
export function toggle(id, IsActive) { return { type: 'STAFF/TOGGLE', id, IsActive } }
export function clean() { return { type: 'COORP/CLEAR' } }